






import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import { getBaseInfo } from './api';

const baseUrl = 'CMBYZ0524';

@Component
export default class ViewHolder extends Vue {
  tabs: any[] = [
    {
      title: '活动主页',
      path: `/${baseUrl}/home`,
      id: 1,
    },
    {
      title: '活动简介',
      path: `/${baseUrl}/rule`,
      id: 2,
    },
  ];
  activeTab = 0;
  baseInfo: any = {};

  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '2023“开放的六月”毕业生作品展“最受大众喜爱作品奖”投票',
      url: location.href,
      subtitle: `来上游新闻，为自己喜爱的毕业作品投票，有机会获得原创作品！`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '2023“开放的六月”毕业生作品展“最受大众喜爱作品奖”投票',
        subtitle: `来上游新闻，为自己喜爱的毕业作品投票，有机会获得原创作品！`,
        image: cover,
      });
    }
  }

  async created() {
    const index = this.tabs.findIndex((item: any) => {
      return item.path === this.$route.path;
    });
    this.activeTab = index > -1 ? index : 0;
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }
}
